import { render } from "./CollapseFrame.vue?vue&type=template&id=4dde1dd5&scoped=true"
import script from "./CollapseFrame.vue?vue&type=script&lang=js"
export * from "./CollapseFrame.vue?vue&type=script&lang=js"

import "./CollapseFrame.vue?vue&type=style&index=0&id=4dde1dd5&lang=scss&scoped=true"

import exportComponent from "/opt/anthos/FBL_OTWS/OTWS_src5/otws-external-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4dde1dd5"]])

export default __exports__